<template>
  <Tooltip class="visible-level-help" placement="bottom-start" theme="light" :max-width="520" :options="tooltipOptions" transfer>
    <Icon class="help-icon" type="md-help-circle" :size="16" aria-label="可见级别说明" />
    <div slot="content" class="help-content">
      <p>高级合伙人能看到高级合伙人、合伙人、王者、精英、新贵、转介人</p>
      <p>合伙人能看到合伙人及王者、精英、新贵、转介人</p>
      <p>王者能看到王者、精英、新贵</p>
      <p>精英能看到精英、新贵</p>
      <p>新贵只能看到新贵</p>
    </div>
  </Tooltip>
</template>

<script>
export default {
  name: 'IfaCommissionVisibleLevelHelp',
  data() {
    return {
      tooltipOptions: {
        modifiers: {
          computeStyle: { gpuAcceleration: false },
          preventOverflow: { boundariesElement: 'window' },
          arrow: { element: '.ivu-tooltip-arrow' }
        }
      }
    };
  }
};
</script>

<style scoped>
.visible-level-help {
  margin-left: 4px;
}
.help-icon {
  color: #a8adb7;
  cursor: help;
}
.help-content {
  max-width: calc(100vw - 48px);
  color: #515a6e;
  font-weight: normal;
  line-height: 22px;
  white-space: normal;
  overflow-wrap: break-word;
  text-align: left;
}
</style>
